<template>
  <img src="@/assets/img/bg-setting-01.svg" class="bg-image" />
</template>

<script lang="ts">
export default {
  name: "BackgroundComponent",
};
</script>

<style lang="scss">
.bg-image {
  position: absolute;
  right: 0;
  z-index: 0;
  object-fit: cover;
  padding-top: 335px;
  @media (max-width: 1280px) {
    max-width: 50vw;
    margin-top: auto;
    bottom: -60px;
  }
  @media (max-width: 767px) {
    max-width: 320px;
    right: 50px;
  }
}
</style>
